// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__2UBIA","row":"Option_row__Jw8kb"};